import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4270a6e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { ref, watch } from "vue";
import Tag from "primevue/tag";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageWithNoImageDefault',
    props: {
        source: {}
    },
    setup(__props) {
        const props = __props;
        const isImageError = ref(false);
        const onImageLoad = () => {
            isImageError.value = false;
        };
        const onImageError = () => {
            isImageError.value = true;
        };
        watch(() => props.source, () => {
            isImageError.value = false;
        });
        return (_ctx, _cache) => {
            return (isImageError.value)
                ? (_openBlock(), _createBlock(_unref(Tag), {
                    key: 0,
                    severity: "secondary",
                    icon: "pi pi-image",
                    value: "No image"
                }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "small-image",
                    src: props.source,
                    onLoad: onImageLoad,
                    onError: onImageError
                }, null, 40, _hoisted_1));
        };
    }
});
